import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';

export const FEATURE_SUBSCRIPTION_COMMUNITIES_RESOURCE = 'featureSubscriptionCommunities';

const featureSubscriptionCommunitiesService = ComposedComponent =>
  reduxFetch([
    {
      resource: FEATURE_SUBSCRIPTION_COMMUNITIES_RESOURCE,
      method: 'get',
      request: (appId, installationId, featureId) => ({
        url: apiRoutes.featureSubscriptionCommunities(appId, installationId, featureId),
      }),
    },
  ])(ComposedComponent);

export default featureSubscriptionCommunitiesService;
